import { authApi } from '@metadevprofile/shared/api';
import * as Sentry from '@sentry/react';
import { setAuthLoading, setUser } from '@/auth/stores/auth-slice';
import { notificationService } from '@/common/lib/notification-service';
import { tokenStorage } from '@/common/lib/token-storage';
import i18n from '@/common/locales/i18n';
import { store } from '@/common/redux/store';

export const signOut = async (): Promise<void> => {
  store.dispatch(setAuthLoading(true));
  try {
    const refreshToken = await tokenStorage.getRefreshToken();

    if (refreshToken) {
      try {
        await store.dispatch(authApi.endpoints.logout.initiate({ refresh_token: refreshToken })).unwrap();
      } catch (error) {
        Sentry.captureException(error);
      }
    }

    await tokenStorage.clearAllTokens();
    notificationService.success(i18n.t('auth:success.signedOut'));
    store.dispatch(setUser(null));
  } finally {
    store.dispatch(setAuthLoading(false));
  }
};
